class ConnectionCardDirective
  @$inject: ['Device']
  constructor: (Device)->              
    class ConnectionCard      
      restrict: "C"
      scope: 
        filter: "="
      require: "^connectionStatistic"
      template: require('./index.pug')
      link: (scope, element, attrs, $statistic)->
        scope.status = status = attrs.status ? null

        if not status
          element.find(".panel").addClass("panel-warning")          
          element.find(".panel .panel-heading i").addClass("fa-desktop")          
          scope.title = "Total Devices"
        else if status is "A"
          element.find(".panel").addClass("panel-success")
          element.find(".panel .panel-heading i").addClass("fa-check")          
          scope.title = "Online"
        else if status is "E"
          element.find(".panel").addClass("panel-danger")
          element.find(".panel .panel-heading i").addClass("fa-power-off")          
          scope.title = "Offline" 
        scope.select = (os=null)-> 
          if scope.filter.os == os and scope.filter.status == status
            scope.filter.os = null  
            scope.filter.status = null
            return

          if os
            scope.filter.os = os
          else
            scope.filter.os = null
          if status
            scope.filter.status = status
          else
            scope.filter.status = null



        $statistic.get().then (result)->           
          scope.android = 0
          scope.linux = 0
          scope.windows = 0
          scope.mac = 0          
          result.forEach (res)->            
            if status is "E" and res._id.status isnt "E"              
              return              
            else if status is "A" and res._id.status isnt "A"              
              return
            switch res._id.os
              when "ANDROID" then scope.android += res.count
              when "LINUX" then scope.linux += res.count
              when "WINDOWS_NT" then scope.windows += res.count
              when "DARWIN" then scope.mac += res.count

          scope.total = scope.android + scope.linux + scope.windows + scope.mac  
          
     
    return new ConnectionCard()

  
module.exports = ConnectionCardDirective


// WEBPACK FOOTER //
// ./src/component/device/statistic/connection.coffee